import React from 'react'

function Footer () {
  return (
    <div>
      <a href="mailto:Kvangel1638@gmail.com">Contact Me</a>
    </div>
  )
}

export default Footer
